import { schema } from 'normalizr';

/* Normalize schema */
export const userSchema = new schema.Entity('actor', {}, { idAttribute: value => value.describes.id });
export const productsSchema = new schema.Entity('orderedProducts', {}, { idAttribute: value => value.productId });
export const cardsSchema = new schema.Entity(
  'cards',
  {
    actor: userSchema,
    orderedProducts: [productsSchema],
    recommendedProfiles: [userSchema]
  },
  {
    idAttribute: 'id'
  }
);
export const cardsArray = new schema.Array(cardsSchema);
